import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IntegrationsFilters, IntegrationsResponse, PlatformContactsResponse, SetupDataResponse, UpdateIntegrationRequest,ContactsFilter, IntegrationAuthMethod, IntegrationPlatform, CRMUserMapping, UpdateCRMUserMapping } from 'voxloud-types/dist/models/integrations/index';
import { Observable } from 'rxjs';
import { AUTHORIZATION_METHOD_TYPE } from 'voxloud-types/dist/models/integrations/index';
import { PlatformsResponse } from '../models/integrations.model';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {

  constructor(private http: HttpClient) { }
  
  public authMethods = {
    [AUTHORIZATION_METHOD_TYPE.OAUTH2]: 'OAuth2',
    [AUTHORIZATION_METHOD_TYPE.API_KEY]: 'API key',
    [AUTHORIZATION_METHOD_TYPE.BASIC]: 'Basic',
    [AUTHORIZATION_METHOD_TYPE.HMAC]: 'HMAC',
    [AUTHORIZATION_METHOD_TYPE.PLATFORM]: 'Platform'
  };

  getIntegrationsByFilter(idPage: number, size: number, filters: IntegrationsFilters ): Observable <IntegrationsResponse> {
    let params = new HttpParams()
    .append('page', idPage)
    .append('size', size)

    if(filters && filters?.company_id) {
      params = params.append('company_id', filters.company_id)
    }
    if(filters && filters?.status) {
      params = params.append('status', filters.status)
    }
    if(filters && filters?.platform_id) {
      params = params.append('platform_id', filters.platform_id)
    }
    if(filters && filters?.enabled) {
      params = params.append('enabled', filters.enabled)
    }

    return this.http.get<IntegrationsResponse>(`${environment.apiEndpoint}/api/v1/integrations`, { params });
  }

  deleteIntegration(id: number) {
    return this.http.delete(`${environment.apiEndpoint}/api/v1/integrations/${id}`);
  }

  getPlatformById(id: number) {
    return this.http.get<IntegrationPlatform>(`${environment.apiEndpoint}/api/v1/integration-platforms/${id}`);
  }

  getAllPlatforms() {
    let params = new HttpParams()
    .append('page', 0)
    .append('size', 200)
    
    return this.http.get<PlatformsResponse>(`${environment.apiEndpoint}/api/v1/integration-platforms`, {params});
  }

  getAuthMethod(id: number) {
    return this.http.get<IntegrationAuthMethod>(
      `${environment.apiEndpoint}/api/v1/integrations/${id}/authorization-method`
    );
  }

  getContactsCount(filters: ContactsFilter) {
    return this.http.post<PlatformContactsResponse>(`${environment.apiEndpoint}/api/v2/contacts/search`, { ...filters });
  }

  getSetupData(id: number) {
    return this.http.get<SetupDataResponse>(`${environment.apiEndpoint}/api/v1/integrations/${id}/setup-data`);
  }

  updateIntegration(id: number, data: UpdateIntegrationRequest) {
    return this.http.put(`${environment.apiEndpoint}/api/v1/integrations/${id}`, { ...data } );
  }

  forceContactSync(company_id: number, platfrom: string) {
    return this.http.put(`${environment.apiEndpoint}/api/v2/contacts/sync?company_id=${company_id}&platform=${platfrom}`, {});
  }

  public getUserMappings(id: number): Observable<CRMUserMapping[]>{
    return this.http.get<CRMUserMapping[]>(
      `${environment.apiEndpoint}/api/v1/integrations/${id}/user-mapping`
    );
  }

  public saveUserMappings(id: number, user_mappings: UpdateCRMUserMapping[]): Observable<{ user_mappings: UpdateCRMUserMapping[] }>{
    return this.http.put<{ user_mappings: UpdateCRMUserMapping[] }>(
      `${environment.apiEndpoint}/api/v1/integrations/${id}/user-mapping`,
      { user_mappings }
    );
  }
}
